import { cva } from "class-variance-authority";

export const choicesInputStyles = {
  root: "flex flex-col gap-2",
  header: "flex items-start justify-between gap-2",
  prompt: "text-sm font-medium text-strong",
  dismissBtn: "shrink-0 rounded-md p-1 text-subtle transition-colors hover:bg-muted hover:text-mid",
  options: "flex flex-col gap-1.5",
  checkIcon: "h-4 w-4 shrink-0 text-primary",
  checkPlaceholder: "h-4 w-4 shrink-0 rounded border border-dim",
  pager: "flex items-center justify-center gap-2",
  pagerBtn:
    "rounded-md p-1 text-subtle transition-colors hover:bg-muted hover:text-mid disabled:opacity-40",
  pagerLabel: "text-xs text-subtle",
  freeTextRow: "flex items-center gap-1.5",
  freeTextInput:
    "w-full min-w-0 rounded-xl border border-border bg-transparent px-3 py-2 text-sm text-strong outline-none placeholder:text-subtle focus:border-primary disabled:opacity-50",
  freeTextSend:
    "shrink-0 rounded-xl bg-primary p-2 text-primary-foreground transition-colors hover:bg-primary-dark disabled:opacity-50",
  submitBtn:
    "mt-1 w-full rounded-xl bg-primary py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-dark disabled:opacity-50",
};

export const choiceOption = cva(
  "flex w-full items-center gap-2 rounded-xl border px-3 py-2 text-left text-sm transition-colors",
  {
    variants: {
      selected: {
        true: "border-primary bg-accent text-strong",
        false: "border-border text-mid hover:border-primary hover:bg-accent",
      },
    },
    defaultVariants: { selected: false },
  },
);
